import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';

import { columns } from './columns';


@Component({
  moduleId: module.id,
  selector: 'receivers-table',
  templateUrl: 'receivers-table.component.html',
  styleUrls: ['receivers-table.component.scss'],
})
export class ReceiversTableComponent extends FrontendSearchWidgetComponent {

  columns: any = columns;
  sortingColumns: any = [];
  searchFilterField: string = 'receiver_name';
  ghostValue: string = 'receiver-search';

  @Input() declare data: any[];

  @Output() resendClick = new EventEmitter();

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isEmpty() {
    return !this.data || !this.data.length;
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onResendClick(receiverDataId: string) {
    this.resendClick.emit(receiverDataId);
  }
}
